export default {
    'squareScript': 'https://sandbox.web.squarecdn.com/v1/square.js',
    'appId': 'sandbox-sq0idb-uuQXlzua_QbnpNB2n2YRXw',
    'locationId': 'LCGGGNKX223G3',
    'termsAndConditions': 'https://safee.com.au/terms-and-conditions'
};
